
/**守护**/
import shouhuTpl from './shouhu.tmpl';
import shouhuUserTpl from './shouhu-user.tmpl'

class ShouHu {

	constructor({hostId=0 ,acid=0,wrap=""}={}){
		this.nodeWrap = $(wrap);
		this.hostId = hostId;
		this.acid = acid;
	}
	render(){
		let actInfo = UpAct.actData[this.acid];
        let pageSize = UpAct.lang.langType == 'zhhk' ? 60:10;
        let params = `{eventId:'${actInfo.overallRanking.id}',uid:'${this.hostId}',pageCount:'${pageSize}'}`;

		let html = shouhuTpl({
			params: params
		});
		this.nodeWrap.html(html);
		$(window).off("scroll");
        window.scrollTo(0,0);
        let container = $('#J-USER-SHOUHU-LIST');
    	let hostListObj = new UpAct.SendUserList({
    		wrap: container,
    	});
    	hostListObj.on('success',(data)=>{
    		let shouhuUserHtml = shouhuUserTpl({
    			data: data
    		});
    		$('#wrap').find('#SHOUHU-USER').html(shouhuUserHtml)
    	});
    	this.hostList = hostListObj.render();
    	this.refresh();


	}
	refresh() {
        let self = this;
        UpAct.refresh.off('refresh');
        UpAct.refresh.on('refresh', function() {
            self.hostList.refresh();
        });
        UpAct.refresh.render();
    }


}
module.exports = ShouHu;


// WEBPACK FOOTER //
// ./js/component/shouhulist/index.js